import { create } from 'zustand'

interface BalanceStore {
  balance: number | null
  setBalance: (balance: number) => void
}

export const useBalanceStore = create<BalanceStore>((set) => ({
  balance: null,
  setBalance: (balance) => set({ balance }),
}))
